import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';

const dataModelerSlice = (rootState: RootState) => rootState.dataModeler;

const dataModelerSelectCurrentSchemaState = createSelector(
  dataModelerSlice,
  ({ currentSchemaId, schemaStates }) =>
    currentSchemaId ? schemaStates[currentSchemaId] ?? null : null,
);

export const dataModelerSelectCurrentSchemaObj = createSelector(
  dataModelerSelectCurrentSchemaState,
  (s) => s?.schemaDataModel ?? null,
);

export const dataModelerSelectCurrentDraftEdits = createSelector(
  dataModelerSelectCurrentSchemaState,
  (s) => s?.draftEdits ?? null,
);

export const dataModelerSelectCurrentUiState = createSelector(
  dataModelerSelectCurrentSchemaState,
  (s) => s?.uiState ?? null,
);
